/**
 * モーダルダイアログを開閉するためのクラス。
 */
export class Modal {
    /**
     * モーダルのインスタンスを作成。
     * @param {string|jQuery} modalContent - モーダルの内容を示すセレクタまたはjQueryオブジェクト。
     * @param {string|jQuery} modalOpenBtn - モーダルを開くボタンを示すセレクタまたはjQueryオブジェクト。
     * @param {string|jQuery} modalCloseBtn - モーダルを閉じるボタンを示すセレクタまたはjQueryオブジェクト。
     */
    constructor(modalContent, modalOpenBtn, modalCloseBtn) {
        /**
         * @type {jQuery}
         * @private
         */
        this.$modal = $(modalContent);

        /**
         * @type {jQuery}
         * @private
         */
        this.$openBtn = $(modalOpenBtn);

        /**
         * @type {jQuery}
         * @private
         */
        this.$closeBtn = $(modalCloseBtn);

        // モーダルの初期化
        this._init();
    }

    /**
     * モーダルを開閉するためのイベントハンドラを初期化。
     * @private
     */
    _init() {
        // WAI-ARIA属性の設定
        this.$modal.attr({
            'role': 'dialog',
            'aria-labelledby': 'modalTitle',  // モーダル内にタイトル要素を持つことを想定
            'aria-hidden': 'true',
            'tabindex': '-1'
        });

        this.$openBtn.on('click', (e) => {
            e.preventDefault();
            this._open();
        });

        this.$closeBtn.on('click', (e) => {
            e.preventDefault();
            this._close();
        });

        // closeはmodalの背景をクリックしても閉じる
        this.$modal.on('click', (e) => {
            if (e.target === this.$modal[0]) {
                this._close();
            }
        });

        // Escapeキーでモーダルを閉じる
        $(document).on('keydown', (e) => {
            if (e.key === 'Escape') {
                this._close();
            }
        });
    }

    /**
     * モーダルをフェードインして開きます。
     * @private
     */
    _open() {
        this.$modal.fadeIn();

        this.$modal.attr('aria-hidden', 'false');

        // モーダルを開いている時は、背後のコンテンツをスクロールできないようにする
        $('body').css('overflow', 'hidden');

        this._trapFocus();

        // モーダルの最初のフォーカス要素にフォーカスを設定
        this.$modal.find(':focusable').first().focus();

    }

    /**
     * モーダルをフェードアウトして閉じます。
     * @private
     */
    _close() {
        this.$modal.fadeOut();
        this.$modal.attr('aria-hidden', 'true');

        // モーダルを閉じている時は、背後のコンテンツをスクロールできるようにする
        $('body').css('overflow', 'auto');

        // モーダルを開いたボタンにフォーカスを戻す
        this.$openBtn.focus();
    }

    /**
     * フォーカストラップの実装。
     * モーダル内でTabキーを使ってフォーカス移動がループするようにします。
     * @private
     */
    _trapFocus() {
        const $focusableElements = this.$modal.find(':focusable');
        const firstFocusableElement = $focusableElements.first();
        const lastFocusableElement = $focusableElements.last();

        this.$modal.on('keydown', (e) => {
            if (e.key === 'Tab') {
                if (e.shiftKey) {
                    // Shift + Tab: 逆方向へのフォーカス移動
                    if ($(document.activeElement).is(firstFocusableElement)) {
                        lastFocusableElement.focus();
                        e.preventDefault();
                    }
                } else {
                    // Tab: 順方向へのフォーカス移動
                    if ($(document.activeElement).is(lastFocusableElement)) {
                        firstFocusableElement.focus();
                        e.preventDefault();
                    }
                }
            }
        });
    }
}